import { Typography } from '@material-ui/core';

const Contact = () => {
  return <Typography />;
};
export default Contact;
